import { Amplify } from 'aws-amplify';
import { environment } from 'environments/environment';

export function configureAmplify(): void {
  const appOrigin = window.location.origin;
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: 'eu-west-1_1PfyOdsBz',
        userPoolClientId: '3i3pp5vpqdn0hefuraempka8qp',
        loginWith: {
          oauth: {
            domain: 'auth.agritrack.org',
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [appOrigin],
            redirectSignOut: [appOrigin],
            responseType: 'code',
          },
          email: true,
        },
      },
    },
  });
}
